<div class="min-w-screen min-h-screen bg-gradient-1 relative flex flex-col">
  <div class="flex items-center justify-center h-screen">
    <div class="animate-spin rounded-full h-24 w-24 border-t-2 border-b-2 border-gray-100"></div>
  </div>
</div>
